import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { Select, Input } from '../../ui';

import { setClientValue } from "../../../actions";
import { options } from "../../../operations";
import { Body, Gender } from '../../Common/Form';
import Continue from "../../Common/Continue";
import {
  validateEmail,
  mapSelectList
} from "../../../helpers";

import iconUser from '../../../assets/icons/icon-user.svg';
import iconEmail from '../../../assets/icons/icon-email.svg';
import iconNumber from '../../../assets/icons/icon-number.svg';
import iconHouse from '../../../assets/icons/icon-house.svg';

class AutoForm_1 extends Component {

  constructor(props) {
    super(props);
    this.state = {
      continue: false
    };
    this.continueCondition = this.continueCondition.bind(this);
    this.getFirstBlockContent = this.getFirstBlockContent.bind(this);
    this.getSecondBlockContent = this.getSecondBlockContent.bind(this);
    this.getThirdBlockContent = this.getThirdBlockContent.bind(this);
  }

  componentDidMount() {
    const { getDepartments } = this.props;
    this.checkContinueState(null);
    getDepartments();
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkContinueState(prevState);

    const { addressState, addressCity, addressStreet, streets } = this.props;
    if (addressState && addressCity && !addressStreet && !streets) {
      const { getStreets } = this.props;
      getStreets({ label: '', value: '' });
    }
  }

  continueCondition() {

    const {
      name, lastName,
      gender, email,
      phoneNumber, addressState,
      addressCity, addressStreet,
      addressNumber
    } = this.props;

    return (
      name && lastName && gender && email && phoneNumber &&
      name != '' &&
      lastName != '' &&
      gender != '' &&
      email != '' &&
      validateEmail(email) &&
      phoneNumber !== '' &&
      phoneNumber.length >= 8 &&
      phoneNumber.length <= 9 &&
      addressState != null &&
      addressCity != null &&
      addressStreet != null &&
      addressNumber != ''
    );
  }

  checkContinueState(prevState) {
    if (this.continueCondition()) {
      if (prevState === null || !prevState.continue) this.setState({ continue: true });
    } else {
      if (prevState === null || prevState.continue) this.setState({ continue: false });
    }
  }

  getFirstBlockContent() {

    const {
      name, showError,
      onValueChange, lastName
    } = this.props;

    return (
      <div className="AutosSoa-formRow">
        <div style={{ flex: 1 }}>
          <Input
            id="name"
            name="name"
            placeholder="Nombre"
            maxLength="50"
            type="text"
            value={name}
            onChange={(event) => { onValueChange('name', event.target.value) }}
            leftIcon={iconUser}
            showAlert={showError && !name}
            autoComplete="nope"
          />
        </div>
        <div style={{ flex: 1 }}>
          <Input
            id="lastName"
            name="lastName"
            placeholder="Apellido"
            maxLength="50"
            type="text"
            value={lastName}
            onChange={(event) => { onValueChange('lastName', event.target.value) }}
            leftIcon={iconUser}
            showAlert={showError && !lastName}
            autoComplete="nope"
            style={{ flex: 1 }}
          />
        </div>
      </div>
    );
  }

  getSecondBlockContent() {

    const {
      showError,
      gender,
      onValueChange
    } = this.props;

    return (
      <Gender
        showError= {showError}
        gender= {gender}
        onChange= {onValueChange}
      />
    );
  }

  getThirdBlockContent() {

    const {
      email, showError,
      onValueChange, phoneNumber,
      addressState, onDepartmentChange,
      departments, addressCity,
      onCityChange, cities,
      onStreetChange, streets,
      addressStreet,
      addressNumber
    } = this.props;

    return (
      <div>
        <div className="AutosSoa-formRow">
          <div style={{ flex: 1 }}>
            <Input
              id="email"
              name="email"
              placeholder="Email"
              maxLength="50"
              type="email"
              value={email}
              onChange={(event) => { onValueChange('email', event.target.value) }}
              leftIcon={iconEmail}
              showAlert={showError && !validateEmail(email)}
              autoComplete="nope"
            />
          </div>
          <div style={{ flex: 1 }}>
            <Input
              id="phoneNumber"
              name="phoneNumber"
              placeholder="Teléfono"
              maxLength="50"
              type="text"
              value={phoneNumber}
              onChange={(event) => { onValueChange('phoneNumber', event.target.value) }}
              leftIcon={iconNumber}
              showAlert={showError && (!phoneNumber ||
                (phoneNumber.length < 8 || phoneNumber.length > 9))}
              autoComplete="nope"
            />
          </div>
        </div>
        <div className="AutosSoa-formRow">
          <div style={{ flex: 1 }}>
            <Select
              id="depto"
              leftIcon={iconHouse}
              name="depto"
              value={addressState}
              showAlert={showError && !addressState}
              onChange={onDepartmentChange}
              placeholder="Seleccione un departamento"
              options={mapSelectList(departments)}
            />
          </div>
          <div style={{ flex: 1 }}>
            <Select
              id="city"
              leftIcon={iconHouse}
              name="city"
              value={addressCity}
              showAlert={showError && !addressCity}
              onChange={onCityChange}
              placeholder="Seleccione una ciudad"
              options={mapSelectList(cities)}
              noOptionsMessage={() => "Sin ciudades. Seleccione el Departamento primero."}
              loadingMessage={() => "Cargando.."}
            />
          </div>
        </div>
        <div className="AutosSoa-formRow">
          <div style={{ flex: 1, paddingBottom: '4px' }}>
            <Select
              id="address"
              leftIcon={iconHouse}
              name="calle"
              value={addressStreet}
              showAlert={showError && !addressStreet}
              onChange={onStreetChange}
              placeholder="Seleccione una calle"
              options={streets !== null ? mapSelectList(streets) : []}
              disabled={(addressCity === null)}
              noOptionsMessage={() => "Sin calles. Seleccione el Departamento y la Ciudad primero, y comience a escribir el nombre"}
              loadingMessage={() => "Cargando.."}
            />
          </div>
          <div style={{ flex: 1 }}>
            <Input
              id="addressNumber"
              name="addressNumber"
              placeholder="Nro. de puerta, manzana, solar"
              maxLength="50"
              type="text"
              value={addressNumber}
              onChange={(event) => { onValueChange('addressNumber', event.target.value) }}
              leftIcon={iconHouse}
              showAlert={showError && !addressNumber}
              autoComplete="nope"
            />
          </div>
        </div>
      </div>
    );
  }

  getFooterContent = () => {
    return (
      <div className="AutosSoa-footer">
        <strong style={{ marginBottom: 4, display: 'block' }}>
          <span style={{ marginRight: 8 }}>
            <span className="icon-help"> ? </span>
          </span>
          ¿Qué es el S.O.A.?
        </strong>
        <span style={{ textTransform: 'uppercase' }}> Seguro Obligatorio <br /> Automotores Ley 18.412 </span>
      </div>
    );
  }

  render() {

    const { continue: toContinue } = this.state;

    return (
      <div>
        <Body columnContent={this.getFirstBlockContent}  />
        <Body columnContent={this.getSecondBlockContent} />
        <Body columnContent={this.getThirdBlockContent}  />
        {/*this.getFooterContent()*/}
        <Continue state={toContinue}/>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    showError: state.steps.showError,

    name: state.client.name,
    lastName: state.client.lastName,
    gender: state.client.gender,
    email: state.client.email,
    phoneNumber: state.client.phoneNumber,

    addressState: state.client.addressState,
    addressCity: state.client.addressCity,
    addressStreet: state.client.addressStreet,
    addressNumber: state.client.addressNumber,

    departments: state.options.departments,
    cities: state.options.cities,
    streets: state.options.streets
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getDepartments: () => {
      dispatch(options.getDepartments());
    },
    onValueChange: (type, value) => {
      dispatch(setClientValue(type, value));
    },
    onDepartmentChange: (addressState) => {
      dispatch(options.setDepartment(addressState));
    },
    onCityChange: (addressCity) => {
      dispatch(options.setCity(addressCity));
    },
    getStreets: (val) => {
      dispatch(options.getStreets(val));
    },
    onStreetChange: (addressStreet) => {
      dispatch(setClientValue('addressStreet', addressStreet));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AutoForm_1);
